import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'remove_non_alphanumeric',
    standalone: false
})
export class RemoveNonAlphanumericPipe implements PipeTransform {

    constructor() {
    }
  transform(string: string) {
      if (typeof string !== 'string') {
          return string;
      }
      return string.replace(/[\W_]+/g, "");
  }
}